import { useCallback } from 'react';

import { useTelemetry } from '@order/Telemetry';

// ─────────────────────────────────────────────────────────────────────

export const useNotificationsTelemetry = () => {
  const { track } = useTelemetry();

  const onPreferenceChanged = useCallback(
    (params: PreferenceChangedParams) => {
      track('notification_preferences.toggled', {
        category: params.category,
        channel: params.channel,
        status: params.value ? 'enabled' : 'disabled',
      });
    },
    [track],
  );

  const onOpenSettings = useCallback(() => {
    track('notification_preferences.device_settings_pressed');
  }, [track]);

  return {
    onPreferenceChanged,
    onOpenSettings,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type PreferenceChangedParams = {
  category: string;
  channel: string;
  value: boolean;
};
